module.exports = __webpack_public_path__ + "static/img/SketchPnga15f6fb86b5941b89fde576ea97a64a0b6ec01fe49eb9eb6d50c552854800404.108be83f.png";